import axios from 'axios'

export default {
  getIcareList(params) {
    return axios.get('/v2/portal/icare/people-detail', { params }).then((response) => response.data)
  },

  getIcareDetail(icareId) {
    return axios.get('/v2/portal/icare/people-detail/' + icareId).then((response) => response.data)
  },

  getAttendanceRecap(icareId, peopleUuid, params = {}) {
    return axios
      .get('/v2/portal/icare/people-detail/' + icareId + '/people/' + peopleUuid + '/attendance-recap', { params })
      .then((response) => response.data)
  },

  submitAction(icareId, peopleUuid, payload) {
    return axios
      .post('/v2/portal/icare/people-detail/' + icareId + '/people/' + peopleUuid + '/action', payload)
      .then((response) => response.data)
  },

  getPeopleWithoutIcare(params) {
    return axios.get('/v2/portal/icare/people-without-icare', { params }).then((response) => response.data)
  },

  savePeopleWithoutIcareFollowup(payload) {
    return axios
      .post('/v2/portal/icare/people-without-icare/followup', payload)
      .then((response) => response.data)
  }
}
